import React from 'react';
import propTypes from 'prop-types';
export const UserPassportIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <g>
            <path
              d="M405.333,0H64C52.218,0,42.667,9.551,42.667,21.333v469.333C42.667,502.449,52.218,512,64,512h341.333
				c35.355,0,64-28.645,64-64V64C469.333,28.645,440.689,0,405.333,0z M426.667,448c0,11.791-9.542,21.333-21.333,21.333h-320
				V42.667h320c11.791,0,21.333,9.542,21.333,21.333V448z"
            />
            <path
              d="M256,64c-82.481,0-149.333,66.853-149.333,149.333S173.519,362.667,256,362.667s149.333-66.853,149.333-149.333
				S338.481,64,256,64z M360.532,192h-41.05c-1.322-26.916-5.184-51.52-11.471-71.81C334.668,135.106,354.266,161.128,360.532,192z
				 M256,317.887c-3.31-4.275-6.809-11.41-9.935-20.787c-5.558-16.676-9.337-38.463-10.761-62.433h41.391
				c-1.424,23.971-5.203,45.757-10.761,62.433C262.809,306.477,259.31,313.611,256,317.887z M235.305,192
				c1.424-23.97,5.203-45.757,10.761-62.433c3.125-9.377,6.624-16.512,9.935-20.787c3.31,4.275,6.809,11.41,9.935,20.787
				c5.558,16.676,9.337,38.463,10.761,62.433H235.305z M203.989,120.19c-6.288,20.29-10.149,44.894-11.471,71.81h-41.05
				C157.734,161.128,177.332,135.106,203.989,120.19z M151.468,234.667h41.05c1.322,26.916,5.184,51.52,11.471,71.81
				C177.332,291.561,157.734,265.539,151.468,234.667z M308.011,306.476c6.288-20.29,10.149-44.894,11.471-71.81h41.05
				C354.266,265.539,334.668,291.561,308.011,306.476z"
            />
            <path
              d="M362.667,405.333H149.333c-11.782,0-21.333,9.551-21.333,21.333S137.551,448,149.333,448h213.333
				c11.782,0,21.333-9.551,21.333-21.333S374.449,405.333,362.667,405.333z"
            />
          </g>
        </g>
      </g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
      <g></g>
    </svg>
  );
};
UserPassportIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
UserPassportIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
